import { ref } from 'vue';
import { defineStore } from "pinia";
import {
  type EmailContactDto,
  type CreateEmailContactDto,
  type UpdateEmailContactDto,
  EmailContactsService,
} from '@/client';

export const useEmailContactStore = defineStore("emailContact", () => {
  const contacts = ref([] as EmailContactDto[]);

  async function list() {
    return await EmailContactsService.getApiEmailContactsList()
      .then((data) => {
        contacts.value = data!;
        return Promise.resolve(data);
      })
      .catch((error: any) => Promise.reject(error));
  }

  async function create(dto: CreateEmailContactDto) {
    return await EmailContactsService.postApiEmailContactsCreate({ requestBody: dto })
      .then((data) => {
        contacts.value.push(data!);
        return Promise.resolve(data);
      })
      .catch((error: any) => Promise.reject(error));
  }

  async function update(dto: UpdateEmailContactDto) {
    return await EmailContactsService.putApiEmailContactsUpdate({ requestBody: dto })
      .then((data) => {
        const idx = contacts.value.findIndex(c => c.id === dto.id);
        if (idx !== -1) contacts.value[idx] = data!;
        return Promise.resolve(data);
      })
      .catch((error: any) => Promise.reject(error));
  }

  async function remove(id: number) {
    return await EmailContactsService.deleteApiEmailContactsDeleteById({ id: String(id) })
      .then(() => {
        contacts.value = contacts.value.filter(c => c.id !== id);
        return Promise.resolve();
      })
      .catch((error: any) => Promise.reject(error));
  }

  return { contacts, list, create, update, remove };
});
